module.exports = __webpack_public_path__ + "static/media/callgage-linkedin.28fdd96c.svg";